var _circle, _circle2, _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTogether = function SvgTogether(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.231,
    cy: 10.001,
    r: 5.711,
    stroke: "currentColor",
    strokeWidth: 1.038
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.769,
    cy: 10.001,
    r: 5.711,
    stroke: "currentColor",
    strokeWidth: 1.038
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "Together_svg__a",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.432 15.16c1.834-1.13 3.028-2.976 3.028-5.06 0-2.085-1.194-3.93-3.028-5.061-1.834 1.13-3.028 2.976-3.028 5.06 0 2.085 1.194 3.93 3.028 5.061",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.432 15.16c1.834-1.13 3.028-2.976 3.028-5.06 0-2.085-1.194-3.93-3.028-5.061-1.834 1.13-3.028 2.976-3.028 5.06 0 2.085 1.194 3.93 3.028 5.061",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m9.432 15.16-.545.884.545.337.545-.337zm0-10.121.545-.884-.545-.336-.545.336zm1.99 5.06c0 1.664-.953 3.201-2.535 4.178l1.09 1.767c2.085-1.286 3.521-3.44 3.521-5.944zM8.887 5.924c1.582.976 2.535 2.513 2.535 4.177h2.076c0-2.506-1.436-4.66-3.52-5.945zM7.442 10.1c0-1.664.952-3.201 2.535-4.177l-1.09-1.768C6.802 5.44 5.365 7.595 5.365 10.1zm2.535 4.177C8.394 13.3 7.442 11.763 7.442 10.1H5.365c0 2.505 1.437 4.658 3.522 5.944z",
    mask: "url(#Together_svg__a)"
  })));
};
export default SvgTogether;